import api from '@/app/services/financeiro/contasfinanceiras';

export default {
  namespaced: true,
  state: {
    conta: {
      id: '',
      nome: '',
      tipo: 'dinheiro',
      saldo_inicial: 0,
      ativo: true,
      padrao: false,
      observacao: '',
    },
    contas: [],
    busca: '',
    total_itens: 0,
    paginacao: {
      page: 1,
      itemsPerPage: 10,
      sortBy: ['nome'],
      sortDesc: [false],
    },
  },

  mutations: {
    LISTAR(state, payload) {
      state.contas = payload;
    },
    ABRIR(state, payload) {
      state.conta = payload;
    },
    ADICIONAR(state, payload) {
      state.contas.unshift(payload);
    },
    ATUALIZAR(state, payload) {
      const index = state.contas.findIndex((item) => item.id == payload.id);
      if (index > -1) {
        state.contas.splice(index, 1, payload);
      }
    },
    EXCLUIR(state, id) {
      const index = state.contas.findIndex((item) => item.id == id);
      if (index > -1) {
        state.contas.splice(index, 1);
      }
    },
    SET_BUSCA(state, busca) {
      state.busca = busca;
    },
    SET_PAGE(state, page) {
      state.paginacao.page = page;
    },
    SET_TOTAL_ITENS(state, total) {
      state.total_itens = total;
    },
    UPDATE_PAGINACAO(state, paginacao) {
      state.paginacao = paginacao;
    },
    ZERAR(state) {
      state.conta = {
        id: '',
        nome: '',
        tipo: 'dinheiro',
        saldo_inicial: 0,
        ativo: true,
        padrao: false,
        observacao: '',
      };
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit('LOADING_ON', null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.paginacao;
      const params = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      if (state.busca) {
        params.busca = state.busca;
      }

      const response = await api.listar(params);
      commit('LISTAR', response.data);
      commit('SET_TOTAL_ITENS', response.total);
      commit('LOADING_OFF', null, { root: true });
    },

    async abrir({ commit }, id) {
      commit('LOADING_ON', null, { root: true });
      const conta = await api.abrir(id);
      commit('ABRIR', conta);
      commit('LOADING_OFF', null, { root: true });
    },

    async salvar({ commit }, payload) {
      const nova = await api.salvar(payload);
      commit('ADICIONAR', nova);
    },

    async atualizar({ commit }, payload) {
      const atualizado = await api.atualizar(payload);
      commit('ATUALIZAR', atualizado);
    },

    async excluir({ commit }, id) {
      await api.excluir(id);
      commit('EXCLUIR', id);
    },
  },
};
